import { db } from '.';

async function getVersionedConceptFromDB(id) {
  const ref = db.collection('versionedConcepts').doc(id);
  const snapshot = await ref.get();
  return {
    id,
    ...snapshot.data()
  };
}

export default {
  get: getVersionedConceptFromDB
};
